module.exports = __webpack_public_path__ + "img/ltkmidsize-1x.2313622.jpg";